import { DateString } from "../types";

const dateStringLabels: Record<DateString, string> = {
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  THIS_WEEK: "This week",
  LAST_WEEK: "Last week",
  THIS_MONTH: "This month",
  LAST_MONTH: "Last month",
  THIS_QUARTER: "This quarter",
  LAST_QUARTER: "Last quarter",
  THIS_YEAR: "This year",
  LAST_YEAR: "Last year",
  LAST_7_DAYS: "Last 7 days",
  LAST_30_DAYS: "Last 30 days",
  LAST_90_DAYS: "Last 90 days",
  LAST_180_DAYS: "Last 180 days",
  LAST_365_DAYS: "Last 365 days",
};

export default dateStringLabels;
